import { render, staticRenderFns } from "./ShapeProperties.vue?vue&type=template&id=85a3994a"
import script from "./ShapeProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShapeProperties.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports